import { useEffect } from 'react'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { Locations, trackExperimentViewed } from '@mc/track-event'
import Link from 'components/Link'
import { MCCERTS_NAVIGATION_TESTING_PRE_PAYWALL_EXP_FLAG } from 'experiments/mccerts-280_v1/constants'
import { trackNavClick } from '../events'

export const CertificatesLink = ({
  className = '',
  location = Locations.NAVIGATION,
}: {
  className?: string
  location?: (typeof Locations)[keyof typeof Locations]
}) => {
  const { t } = useTranslation('@mc/next')

  const ctaCopy = t('nav.cta.certificates')

  useEffect(() => {
    trackExperimentViewed(MCCERTS_NAVIGATION_TESTING_PRE_PAYWALL_EXP_FLAG)
  }, [])

  const handleCertificatesClick = () => {
    trackNavClick(ctaCopy, undefined, location)()
  }

  return (
    <Link
      href={paths.certificates}
      className={`mc-ml-4 ${className}`}
      onClick={handleCertificatesClick}
      passHref
    >
      {ctaCopy}
    </Link>
  )
}
